

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import empty from "../../assets/images/empty-box.png";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import moment from "moment/moment";

export default function SelectedStudent() {
    const [students, setStudents] = useState([]);

    useEffect(() => {
        fetchStudents();
    }, []);

    const fetchStudents = async () => {
        try {
            const response = await axios.get(`${baseUrl}/selected_student/all`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            });
            setStudents(response.data.data || []);
        } catch (error) {
            console.error("error", error);
        }
    };

    const handleStatus = async (id) => {
        try {
            const res = await axios.put(`${baseUrl}/selected_student/${id}`, {}, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            });

            if (res?.data?.status) {
                // Update local state without refetching
                setStudents((prev) =>
                    prev.map((student) =>
                        student._id === id
                            ? { ...student, status: student.status === "active" ? "inactive" : "active" }
                            : student
                    )
                );

                Swal.fire({
                    title: "Status Changed!",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        } catch (err) {
            console.error("Status change failed", err);
        }
    };

    const handleDelete = async (id) => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });

        if (confirm.isConfirmed) {
            try {
                const res = await axios.delete(`${baseUrl}/selected_student/${id}`, {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                    },
                });

                if (res?.data?.status) {
                    // Remove from local state
                    setStudents((prev) => prev.filter((student) => student._id !== id));

                    Swal.fire("Deleted!", "Student has been deleted.", "success");
                }
            } catch (err) {
                Swal.fire("Error!", "Something went wrong while deleting.", "error");
            }
        }
    };

    return (
        <>
            <section className="main-sec">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="dashboard-title">
                            <h4 className="dash-head">
                                <i className="fa fa-chart-bar me-2" />
                                Selected Students
                            </h4>
                        </div>
                        <div className="custom-bredcump">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Selected Students
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end align-items-start">
                        <Link to="/selected-students/create" className="btn-add-question">
                            <FontAwesomeIcon icon={faPlus} className="me-2" />
                            Add Selected Student
                        </Link>
                    </div>
                    <div className="col-lg-12">
                        <div className="cards bus-list">
                            <div className="bus-filter">
                                <div className="row ">
                                    <div className="col-lg-6">
                                        <h5 className="card-title">Selected Students List</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="table table-responsive custom-table">
                                <table className="table table-borderless">
                                    <thead>
                                        <tr>
                                            <th>Image</th>
                                            <th>SN</th>
                                            <th>Name</th>
                                            <th>Exam</th>
                                            <th>Roll No.</th>
                                            <th>Exam Year</th>
                                            <th>From</th>
                                            <th>Selected At</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {students.length === 0 ? (
                                            <tr>
                                                <td colSpan="9" className="py-5 text-center">
                                                    <img src={empty} alt="" width="200px" />
                                                    <h4 className="py-2">No Students Found!</h4>
                                                </td>
                                            </tr>
                                        ) : (
                                            students.map((rev, i) => (
                                                <tr key={rev?._id}>
                                                    <td>
                                                        <img
                                                            src={`${baseUrl}/${rev?.photo}` || "/jslogo.png"}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = "/jslogo.png";
                                                            }}
                                                            alt=""
                                                            style={{ width: "100px" }}
                                                        />
                                                    </td>
                                                    <td>{i + 1}</td>
                                                    <td>{rev?.name}</td>
                                                    <td>{rev?.exam}</td>
                                                    <td>{rev?.roll_number}</td>
                                                    <td>{rev?.exam_year}</td>
                                                    <td>
                                                        {rev?.city} / {rev?.state}
                                                    </td>
                                                    <td>
                                                        {moment(rev?.selectedAt).format('ll')}
                                                    </td>
                                                    <td>
                                                        <button
                                                            onClick={() => handleStatus(rev?._id)}
                                                            className={
                                                                rev.status === "active"
                                                                    ? "btn btn-pill btn-primary btn-sm"
                                                                    : "btn btn-pill btn-danger btn-sm"
                                                            }
                                                        >
                                                            {rev.status === "active" ? "Active" : "Inactive"}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Link
                                                                to={`view/${rev?._id}`}
                                                                className="action-btn edit-btn"
                                                            >
                                                                <i className="fa fa-eye"></i>
                                                                <span className="tooltip-text">View</span>
                                                            </Link>
                                                            <button
                                                                className="action-btn delete-btn"
                                                                onClick={() => handleDelete(rev?._id)}
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                                <span className="tooltip-text">Delete</span>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
